import * as React from "react";
import { css } from "@emotion/core";
import { Icon } from "@blueprintjs/core";

interface DeleteTagConfirmationProps {
  tagLabel: string;
  surveyCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

function surveyCountMessage(count: number): string {
  if (count === 0) {
    return "This tag has not been applied to any surveys.";
  }
  if (count === 1) {
    return "This will remove it from 1 survey it has been applied to.";
  }
  return `This will remove it from ${count} surveys it has been applied to.`;
}

export function DeleteTagConfirmation({
  tagLabel,
  surveyCount,
  onCancel,
  onConfirm,
}: DeleteTagConfirmationProps) {
  return (
    <div
      css={css`
        padding: 0.5rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
      `}
    >
      <div
        css={css`
          color: var(--neutral-3);
          font-size: 14px;
          margin: 0;
        `}
      >
        <div
          css={css`
            margin-left: 0.5rem;
            line-height: 1.3rem;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          `}
        >
          <div
            css={css`
              display: flex;
              gap: 0.5rem;
            `}
          >
            <Icon icon="warning-sign" color="var(--danger)" size={16} />
            <span>
              Delete tag <strong>'{tagLabel}'</strong>?
            </span>
          </div>
          <strong
            css={css`
              color: var(--neutral-4);
              font-size: 12px;
            `}
          >
            {surveyCountMessage(surveyCount)}
          </strong>
        </div>
      </div>
    </div>
  );
}
